// Canonical production origin. Structured data (JSON-LD @id / item / url) must
// use ABSOLUTE URLs — Google flags relative URLs in those fields as invalid
// (e.g. BreadcrumbList items showed "Invalid URL in field 'id'").

export const SITE_URL = "https://coolsymbols.cool";

/** Resolve a site-relative path to an absolute URL for structured data. */
export function abs(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
